import OrderOptimizerDetailsUpdateParams, {
  OrderOptimizerDetailsUpdateParamsStatus,
} from "../../../../../common/services/order-optimizer/details/update/order-optimizer-details-update-params";
import { OrderOptimizerRailyDetailsItemStatus } from "./types/order-optimizer-raily-details-item";

const createStatus = (
  status: OrderOptimizerRailyDetailsItemStatus,
): OrderOptimizerDetailsUpdateParamsStatus => {
  switch (status) {
    case OrderOptimizerRailyDetailsItemStatus.INTERESTING:
      return OrderOptimizerDetailsUpdateParamsStatus.INTERESTING;
    case OrderOptimizerRailyDetailsItemStatus.PENDING:
      return OrderOptimizerDetailsUpdateParamsStatus.PENDING;
    case OrderOptimizerRailyDetailsItemStatus.REJECTED:
      return OrderOptimizerDetailsUpdateParamsStatus.REJECTED;
  }
};

const create = (
  id: string,
  status: OrderOptimizerRailyDetailsItemStatus,
): OrderOptimizerDetailsUpdateParams => {
  return {
    id: id,
    status: createStatus(status),
  };
};

const orderOptimizerRailyDetailsUpdateParamsFactory = {
  create,
};

export default orderOptimizerRailyDetailsUpdateParamsFactory;
